/// <reference path="../_references.ts"/>

module App.Customer {
	import TitleBarService = App.Helpers.TitleBarService;
	import ServiceRequest = App.Customer.ServiceRequest;
	import Appointment = App.Customer.Appointment;
	import Technician = App.Administrative.Inventory.Technician;
	import State = App.Helpers.State;
	import ServiceRequestType = App.Appointments.ServiceRequestType;
	import DispatchCode = App.Customer.DispatchCode;
	import LeadSource = App.Appointments.LeadSource;
	import PaymentType = App.Payment.PaymentType;
	import Salesman = App.Appointments.Salesman;
	import ToastService = App.Utils.ToastService;
	import Location = App.DispatchService.Location;
	import AppointmentService = App.Appointments.AppointmentService;
	import UserSession = App.User.UserSession;
	import OrganizationService = App.Utils.OrganizationService;
	import OrganizationSRDisplayData = App.Utils.OrganizationSRDisplayData;

	export class CustomerServiceRequestController {
		static $inject = ['$timeout', 'UserSession', 'AppointmentService', 'CustomerService', 'SelectedCustomer', 'TitleBarService', 'ToastService', 'DispatchService', 'Validations', 'States', '$state', 'OrganizationService'];

		addressFilter: string;
		appointment: Appointment;
		appointmentForm: ng.IFormController;
		customer: SelectedCustomer;
		dispatchCode: DispatchCode;
		isSearching: boolean;
		selectedLocation: Location;
		org: OrganizationSRDisplayData;
		locations: Location[];
		newAddress: Address;
		newServiceAddressForm: ng.IFormController;
		results: Customer[];
		selectedServiceRequestAddress: Address;
		showNewAddressForm: boolean;
		technicians: Technician[];
		dispatchCodes: DispatchCode[];
		serviceRequest: ServiceRequest = new ServiceRequest();
		serviceRequestTypes: ServiceRequestType[];
		paymentTypes: PaymentType[];
		leadSources: LeadSource[];
		salesmen: Salesman[];
		query: string;
		today: Date;
		srDate: Date;
		srTime: Date;
		showMdl: boolean = false;
		isSaving: boolean = false;
		hideLocations: boolean = false;

		constructor(
			protected $timeout: ng.ITimeoutService,
			public UserSession: UserSession,
			public AppointmentService: AppointmentService,
			public CustomerService: CustomerService,
			public SelectedCustomer: SelectedCustomer,
			public TitleBarService: TitleBarService,
			public ToastService: ToastService,
			private dispatchService: DispatchService.DispatchService,
			public validation: Validations.Validations,
			public states: State[],
			public $state: ng.ui.IStateService,
			protected OrganizationService: OrganizationService
		) {
			const vm = this;

			TitleBarService.set('Home');

			vm.SelectedCustomer.addCallback(vm.customerLoaded);
			vm.SelectedCustomer.loadFromStorage();
			vm.getTechnicians();
			vm.getLocations();
			vm.getDispatchCodes();
			vm.getServiceRequestTypes();
			vm.getPaymentTypes();
			vm.getLeadSources();
			vm.getSalesPersons();
			vm.setDateAndTime();

			OrganizationService.getSRDisplayDetails().then((org) => {
				vm.org = org.data;
			});
		}

		showNewServiceAddressForm() {
			const vm = this;

			vm.showNewAddressForm = true;
			this.newAddress = new Address();
		}

		hideNewServiceAddressForm() {
			const vm = this;

			vm.showNewAddressForm = false;
			this.newAddress = new Address();
		}

		searchServiceAddresses () {
			this.SelectedCustomer.loadServiceAddreses(this.addressFilter);
		}

		saveNewAddress(address: Address) {
			const vm = this;

			address.location = vm.selectedLocation;

			if(vm.locations.length === 1) {
				address.location = vm.locations[0];
			}

			vm.SelectedCustomer.addServiceAddress(address).then(() => {
				vm.hideNewServiceAddressForm();
			});

		}

		goTo(sref: string) {
			this.$state.go(sref);
		}

		getTechnicians() {
			const vm = this;

			vm.CustomerService.fetchTechnicians().then(
				(response) => {
					vm.technicians = response.data;
				}
			)
		}

		getDispatchCodes() {
			const vm = this;

			vm.CustomerService.fetchDispatchCodes().then(
				(response) => {
					vm.dispatchCodes = response.data;
				}
			)
		}

		getServiceRequestTypes() {
			const vm = this;

			vm.CustomerService.fetchServiceRequestTypes().then(
				(response) => {
					vm.serviceRequestTypes = response.data;
				}
			)
		}

		getPaymentTypes() {
			const vm = this;

			vm.CustomerService.fetchPaymentTypes().then(
				(response) => {
					vm.paymentTypes = response.data;
				}
			)
		}

		getLeadSources() {
			const vm = this;

			vm.CustomerService.fetchLeadSource().then(
				(response) => {
					vm.leadSources = response.data;
					vm.leadSources.push({
						id: -1,
						name: 'Lead Tracking',
						description: '',
						number: -1,
						status: true
					});
				}
			)
		}

		getSalesPersons() {
			const vm = this;

			vm.CustomerService.fetchSalesmen().then(
				(response) => {
					vm.salesmen = response.data;
				}
			)
		}

		createServiceRequest(status: number) {
			const vm = this;
			let sr = new ServiceRequest();

			vm.isSaving = true;
			sr.after_hours = vm.serviceRequest.after_hours || false;
			sr.service_request_status = status > 1 ? 2 : 1;
			sr.create_appointment = status > 1 ? (status - 1) : null;
			sr.customer = vm.SelectedCustomer.id;
			sr.service_address = vm.selectedServiceRequestAddress.id;
			sr.technician = vm.appointment.technician;
			sr.description = vm.serviceRequest.description;
			sr.payment_type = vm.serviceRequest.payment_type;
			sr.service_request_type = vm.serviceRequest.service_request_type;
			sr.dispatch_code = vm.dispatchCode ? vm.dispatchCode.id : null;
			sr.lead_source = vm.serviceRequest.lead_source ? (vm.serviceRequest.lead_source.id !== -1 ? vm.serviceRequest.lead_source : null) : null;
			sr.department = vm.dispatchCode ? vm.dispatchCode.department.id : null;
			sr.promised_date = moment(vm.srDate).format('YYYY-MM-DD');
			sr.promised_time = moment(vm.srTime).format('HH:mm');

			vm.CustomerService.createServiceRequest(sr)
				.then((response) => {
					vm.ToastService.show('Request created!');
					vm.$state.go('zipSolutions.home.appointment');
				}).catch((err) => {
					vm.ToastService.showError('Error creating appointment: ', err);
				}).finally(() => vm.isSaving = false);
		}

		getLocations(): void {
			const vm = this;
			this.dispatchService.getLocations().then(function(response) {
				vm.locations = response.data;

				if(vm.locations.length === 1) {
					vm.hideLocations = true;
				}
			});

		}

		customerLoaded():void {
			const vm = this;

			vm.customer = vm.SelectedCustomer;
		}

		setDateAndTime() {
			const vm = this;
			let m = moment();

			vm.srDate = new Date();
			vm.srTime = m.minute() || m.second() || m.millisecond() ? m.add(1, 'hour').startOf('hour').toDate() : m.startOf('hour').toDate();
		}

		clearSearchResults(): void {
			this.results = [];
			this.query = '';
		}

		search(query: string) : void {
			let vm = this;

			vm.results = [];
			vm.isSearching = true;

			if(query.length > 2) {
				this.CustomerService.search(query).then((response) => {
					vm.results = response.data;
					vm.isSearching = false;
				});
			}
		}

		selectAddress(address: Address): void {
			let vm = this;

			vm.selectedServiceRequestAddress = address;
			vm.upgradeMdlInputs();
			vm.checkAfterHours();
		}

		upgradeMdlInputs():void  {
			const vm = this;
			vm.showMdl = false;
			vm.$timeout(() => {
				vm.showMdl = true;
				vm.$timeout(() => {
					componentHandler.upgradeAllRegistered();
				})
			});
		}

		checkAfterHours() {
			const vm = this;

			var apptTime,
				location = vm.SelectedCustomer.getServiceAddressLocation(vm.selectedServiceRequestAddress.id),
				start,
				stop;

			if (location) {
				start = moment(location.after_hours_start, 'HH:mm');
				stop = moment(location.after_hours_end, 'HH:mm').add(1, 'days');
				apptTime = moment({
					hour: moment(vm.srTime).hour(),
					minute: moment(vm.srTime).minute()
				});

				vm.serviceRequest.after_hours = apptTime.isBetween(start, stop);
			}

			vm.upgradeMdlInputs();
		}
	}
}
